<template>
    <v-snackbar top right v-model="$store.state.snackbar" :color="$store.state.snackbarColor">
        {{ $store.state.snackbarMessage }}
        <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="$store.dispatch('snackbarToggle', snackData)">X</v-btn>
        </template>
    </v-snackbar>
</template>


<script>
export default {
    name: 'snackBar',
    data() {
        return {
            snackData: {
                open: false,
                color: '',
                message: '',
            }

        }

    }
}

</script>
